import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useIntl } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import { isMainSearchTypeKeywords } from '../../util/search';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainerStyled from '../TopbarContainer/TopbarContainerStyled';
import FooterStyled from '../FooterContainer/FooterStyled';

import '../../styles/tailwind.css';

const NotFoundPageView = (props: any) => {
  const { scrollingDisabled, staticContext } = props;
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const intl = useIntl();

  // Set 404 status for SSR
  if (staticContext) {
    staticContext.notfound = true;
  }

  const title = intl.formatMessage({ id: 'NotFoundPage.title' });
  const isKeywordSearch = isMainSearchTypeKeywords(config);

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.querySelector('input');
    const keywords = input?.value?.trim();
    if (keywords) {
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, { keywords })
      );
    }
  };

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={<TopbarContainerStyled />}
        footer={<FooterStyled />}
      >
        <div className="styled-page flex flex-col items-center justify-center min-h-[60vh] px-4 py-16">
          <div className="text-center max-w-lg">
            <div className="text-8xl font-bold text-muted-foreground/30 mb-4">404</div>
            <h1 className="text-2xl font-bold mb-3">
              {intl.formatMessage({ id: 'NotFoundPage.heading' })}
            </h1>
            <p className="text-muted-foreground mb-8">
              {intl.formatMessage(
                { id: 'NotFoundPage.description' },
                { marketplaceName: config.marketplaceName }
              )}
            </p>
            <form onSubmit={handleSearchSubmit} className="flex gap-2 max-w-sm mx-auto">
              <input
                type="text"
                placeholder={intl.formatMessage({ id: 'NotFoundPage.SearchForm.placeholder' })}
                className="flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              />
              <button
                type="submit"
                className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {intl.formatMessage({ id: 'NotFoundPage.screenreader.search' })}
              </button>
            </form>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = (state: any) => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const NotFoundPageViewConnected = compose(connect(mapStateToProps))(NotFoundPageView);

export default NotFoundPageViewConnected;
